import Autocomplete from '@mui/material/Autocomplete';
import { alpha, styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import React from 'react';
import { E2Eprocess } from '../process-integration-state';

const PREFIX = 'ProcessSelector';

const classes = {
  selectorBox: `${PREFIX}-selectorBox`,
  icon: `${PREFIX}-icon`,
  clearIcon: `${PREFIX}-clearIcon`,
  mylistText: `${PREFIX}-mylistText`,
  autoComplete: `${PREFIX}-autoComplete`,
  processHeader: `${PREFIX}-processHeader`,
  groupLabel: `${PREFIX}-groupLabel`,
  processSelectorContainer: `${PREFIX}-processSelectorContainer`
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.selectorBox}`]: {
    backgroundColor: alpha(theme.palette.background.default, 0.08),
    color: 'white'
  },

  [`& .${classes.icon}`]: {
    color: 'white'
  },

  [`& .${classes.clearIcon}`]: {
    display: 'none'
  },

  [`& .${classes.mylistText}`]: {
    color: alpha(theme.palette.grey[900], 0.9),
    listStyle: 'none',
    margin: 0,
    padding: '8px 0px',
    position: 'relative'
  },

  [`& .${classes.autoComplete}`]: {
    float: 'left'
  },

  [`& .${classes.processHeader}`]: {
    float: 'left',
    marginRight: theme.spacing(2),
    color: 'white'
  },

  [`& .${classes.groupLabel}`]: {
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, 0.11)
    },
    '&[aria-selected="true"]': {
      backgroundColor: `${alpha(theme.palette.primary.main, 0.11)}!important`
    }
  },

  [`&.${classes.processSelectorContainer}`]: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  }
}));

interface ProcessSelectorProps {
  processes: E2Eprocess[];
  onSelect: (selected: E2Eprocess | null) => void;
  selectedValue?: E2Eprocess | null;
}

const ProcessSelector = ({ processes, onSelect, selectedValue = null }: ProcessSelectorProps) => {
  return (
    <Root className={classes.processSelectorContainer}>
      <Typography variant="subtitle1" className={classes.processHeader}>
        Process
      </Typography>
      <Autocomplete
        id="combo-box-demo"
        blurOnSelect
        ListboxProps={{
          className: classes.mylistText,
          id: 'listbox'
        }}
        options={processes}
        getOptionLabel={option => option.title}
        value={selectedValue}
        classes={{
          popupIndicator: classes.icon,
          clearIndicator: classes.clearIcon,
          root: classes.autoComplete,
          option: classes.groupLabel
        }}
        renderInput={params => (
          <TextField
            {...params}
            InputProps={{
              ...params.InputProps,
              disableUnderline: true,
              className: `${params.InputProps.className} ${classes.selectorBox}`,
              style: { padding: '8px', width: 300 }
            }}
            inputProps={{
              ...params.inputProps,
              'data-testid': 'e2e-value'
            }}
            placeholder="Select Process"
            variant="filled"
          />
        )}
        onChange={(event: React.ChangeEvent<{}>, newValue: E2Eprocess | null) => {
          onSelect(newValue);
        }}
      />
    </Root>
  );
};

export default ProcessSelector;
